import * as React from "react";
import { memo } from "react";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import ArticleIcon from "@mui/icons-material/Article";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import CloudSyncIcon from "@mui/icons-material/CloudSync";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import CardMembershipIcon from "@mui/icons-material/CardMembership";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import LanguageIcon from "@mui/icons-material/Language";
import { ToastContainer } from "react-toastify";
import { styled, useTheme } from "@mui/material/styles";
import OverlayLoader from "../../OverlayLoader";
import AutoGraphIcon from "@mui/icons-material/AutoGraph";
import MuiAppBar, { AppBarProps as MuiAppBarProps } from "@mui/material/AppBar";
import { useDispatch, useSelector } from "react-redux";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import parse from "html-react-parser";
import { useNavigate } from "react-router-dom";
import { formatDate, getMysqlDate } from "../../../utils/generals";
import AuthTypes from "../../../redux/constants";
import { openSystemBrowser } from "../../../utils/electronFunctions";
import { showToast } from "../../../utils/toast";
import HttpClient from "../../../helpers/HttpClient";
import { syncData } from "../../../helpers/sync";
import AlertModal from "../../Tests/components/AlertModal";
import ProgressModal from "../../ProgressModal";
import exportDiscPdf from "../../../helpers/ExportPDF";
const drawerWidth = 300;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})<AppBarProps>(({ theme, open }) => ({
  transition: theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

function MenuFooter({ isCourse, open, courseCode, legalPage, website }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const authState = useSelector((state) => state.auth);
  const [openLoader, setOpenLoader] = React.useState(false);
  const [showLegal, setShowLegal] = React.useState(false);
  const [showProgress, setShowProgress] = React.useState(false);

  const closeSession = () => {
    dispatch({
      type: AuthTypes.LOGOUT,
    });
    navigate("/");
  };

  const checkLesson = (lesson) => {
    if (lesson.operativa == 1) return lesson.viewed == 1;
    return (
      lesson.sublessons &&
      Array.isArray(lesson.sublessons) &&
      lesson.sublessons.length > 0 &&
      lesson.sublessons.filter((ele) => ele.viewed == 0).length == 0
    );
  };

  const checkUnit = (unit) => {
    return (
      unit.lessons &&
      Array.isArray(unit.lessons) &&
      unit.lessons.length > 0 &&
      unit.lessons.filter((ele) => ele.viewed == 0).length == 0
    );
  };

  const getContance = async () => {
    setOpenLoader(true);
    const constancia_porc_lecciones = [];
    const constancia_porc_formularios = [];
    const constancia_porc_tests = [];
    const userId =
      authState && authState.user ? authState.user.email : "test";
    const request = await HttpClient().get(
      `/courses/course/${userId}/${courseCode}`
    );

    console.log(request);
    if (request.error) {
      setOpenLoader(false);
      showToast(
        "No se pudo cargar información del test. Refresca la página e intenta nuevamente.",
        "error"
      );
      return;
    }

    const units = request.data.units;
    let dataMenu = [];

    let sublessonsEV = [];

    if (units) {
      dataMenu = units;

      const lessonIds = request.data.lessons.map((ele) => ele.cod_leccion);
      const sublessonsRequest = await HttpClient().post(
        `/lessons/sublessons-by-lessons-ids/${userId}`,
        {
          lessonIds: lessonIds.join(","),
        }
      );

      for (let i = 0; i < dataMenu.length; i++) {
        const lessons = request.data.lessons.filter(
          (ele) => ele.cod_unidad == dataMenu[i]["cod_unidad"]
        );
        if (lessons) {
          if (!sublessonsRequest.error) {
            for (let j = 0; j < lessons.length; j++) {
              const sublessons = sublessonsRequest.data.filter(
                (ele) => ele.cod_leccion == lessons[j].cod_leccion
              );
              if (sublessons && sublessons.length) {
                sublessons.map(function (sub) {
                  sub["cod_unidad"] = dataMenu[i].cod_unidad;
                });
                sublessonsEV = [
                  ...sublessonsEV,
                  ...sublessons.filter((ele) =>
                    ["EV", "EVSU", "EVSM"].includes(ele.tipo)
                  ),
                ];
                lessons[j]["sublessons"] = sublessons;
                lessons[j]["viewed"] = checkLesson(lessons[j]) ? 1 : 0;
              }
            }
            dataMenu[i]["lessons"] = lessons;
            dataMenu[i]["viewed"] = checkUnit(dataMenu[i]);
          }
        } else {
          dataMenu[i]["lessons"] = [];
          dataMenu[i]["viewed"] = 1;
        }
      }

      console.log(dataMenu);

      const configuration = await HttpClient().get(
        `/configuration/${courseCode}`
      );

      if (configuration && configuration.data) {
        const courseconfiguration = configuration.data;
        for (let i = 0; i < dataMenu.length; i++) {
          if (dataMenu[i].lessons.length > 0) {
            for (let j = 0; j < dataMenu[i].lessons.length; j++) {
              if (
                dataMenu[i].lessons[j].sublessons &&
                dataMenu[i].lessons[j].sublessons.length > 0
              ) {
                const sublessons = dataMenu[i].lessons[j].sublessons;
                const tests = sublessons.filter(
                  (ele) => ele.test_id && ele.test_id != ""
                );
                const forms = sublessons.filter(
                  (ele) => ele.cod_formulario && ele.cod_formulario != ""
                );
                const restlessons = sublessons.filter(
                  (ele) =>
                    !ele.cod_formulario && !ele.test_id && ele.tipo != "EV"
                );
                if (restlessons.length > 0) {
                  constancia_porc_lecciones.push(
                    (restlessons.filter((ele) => ele.viewed == 1).length *
                      100) /
                      restlessons.length
                  );
                }
                if (forms.length > 0) {
                  constancia_porc_formularios.push(
                    (forms.filter((ele) => ele.viewed == 1).length * 100) /
                      forms.length
                  );
                }
                if (tests.length > 0) {
                  constancia_porc_tests.push(
                    (tests.filter((ele) => ele.viewed == 1).length * 100) /
                      tests.length
                  );
                }
              }
              if (dataMenu[i].lessons[j].operativa == 1) {
                constancia_porc_lecciones.push(
                  dataMenu[i].lessons[j].viewed == 1 ? 100 : 0
                );
              }
            }
          }
        }

        const constancia_porc_lecciones_percent =
          constancia_porc_lecciones.length
            ? parseInt(
                constancia_porc_lecciones.reduce(
                  (accumulator, currentValue) => {
                    return accumulator + currentValue;
                  },
                  0
                )
              ) / constancia_porc_lecciones.length
            : 100;

        const constancia_porc_formularios_percent =
          constancia_porc_formularios.length > 0
            ? parseInt(
                constancia_porc_formularios.reduce(
                  (accumulator, currentValue) => {
                    return accumulator + currentValue;
                  },
                  0
                )
              ) / constancia_porc_formularios.length
            : 100;

        const constancia_porc_tests_percent =
          constancia_porc_tests.length > 0
            ? parseInt(
                constancia_porc_tests.reduce((accumulator, currentValue) => {
                  return accumulator + currentValue;
                }, 0)
              ) / constancia_porc_tests.length
            : 100;
        console.log(constancia_porc_lecciones);

        if (
          courseconfiguration.constancia_porc_lecciones <=
            constancia_porc_lecciones_percent &&
          courseconfiguration.constancia_porc_formularios <=
            constancia_porc_formularios_percent &&
          courseconfiguration.constancia_porc_tests <=
            constancia_porc_tests_percent &&
          sublessonsEV.filter((ele) => ele.viewed == 0) == 0
        ) {

          const filePath = `/constancias/${ request?.data?.cc ? request?.data?.cc : courseCode}.pdf`;

          const userFullName =
            authState && authState.user
              ? authState.user.nombre_completo
              : "test";
          const today = formatDate(new Date(getMysqlDate())).split("-");
          const months = [
            "Enero",
            "Febrero",
            "Marzo",
            "Abril",
            "Mayo",
            "Junio",
            "Julio",
            "Agosto",
            "Septiembre",
            "Octubre",
            "Noviembre",
            "Diciembre",
          ];

          const customFonts = [
            {
              name: "BonheurRoyale-Regular",
              font: "/commonassets/BonheurRoyale-Regular.ttf",
            },
          ];

          const objText = {
            nombre: {
              value: userFullName,
              fontFamily: "BonheurRoyale-Regular",
              textAlign: "Center",
              fontSize: 25,
            },
            identificacion: {
              value:
                authState && authState.user
                  ? authState.user.documento
                  : "test",
              textAlign: "Center",
            },
            dia: {
              value: today[2],
              textAlign: "Center",
            },
            mes: {
              value: months[parseInt(today[1]) - 1].toLowerCase(),
              textAlign: "Center",
            },
            ano: {
              value: today[0],
              textAlign: "Center",
            },
          };

          exportDiscPdf(objText, [], filePath, customFonts);
        } else {
          showToast(
            "No es posible generar la constancia ya que te falta realizar actividades y/o Evaluaciones."
          );
        }
      } else {
        showToast("Ocurrió un error. Intenta nuevamente.");
      }
    } else {
      showToast("Curso sin contenido.");
    }
    setOpenLoader(false);
  };

  const pages = [
    {
      id: "close-session",
      text: "Cerrar sesión",
      hidden: false,
      icon: (color) => {
        return <ExitToAppIcon sx={{ color: color }} />;
      },
    },
    /*{
      id: 'sync',
      text: 'Sincronizar',
      hidden: false,
      icon: (color) => {
        return <CloudSyncIcon sx={{ color: color }} />;
      },
    },*/
    {
      id: "certificate",
      text: "Constancia",
      hidden: isCourse ? false : true,
      icon: (color) => {
        return <CardMembershipIcon sx={{ color: color }} />;
      },
    },
    {
      id: "stadictics",
      text: "Progreso",
      hidden: isCourse && courseCode == "LEVE" ? false : true,
      icon: (color) => {
        return <AutoGraphIcon sx={{ color: color }} />;
      },
    },
    {
      id: "legal",
      text: "Página legal",
      hidden: false,
      icon: (color) => {
        return <ArticleIcon sx={{ color: color }} />;
      },
    },
    /*{
      id: 'downloads',
      text: 'Centro de descargas',
      hidden: isCourse ? false : true,
      icon: (color) => {
        return <CloudDownloadIcon sx={{ color: color }} />;
      },
    }*/
  ];

  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(
    null
  );
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(
    null
  );

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };

  const showProgressModal = (value) => {
    setShowProgress(value);
  };

  const handleClickNavMenu = async (id) => {
    setAnchorElNav(null);
    switch (id) {
      case "close-session":
        closeSession();
        break;

      case "sync":
        confirmAlert({
          title: "Confirmar",
          message:
            "¿Deseas realizar el proceso de sincronización? Debes tener una conexión a internet estable. Este proceso puede durar algunos minutos.",
          buttons: [
            {
              label: "Sincronizar",
              onClick: async () => {
                setOpenLoader(true);
                const userId =
                  authState && authState.user
                    ? authState.user.email
                    : "test";
                try {
                  const result = await syncData(userId);
                  setOpenLoader(false);
                  if (result.error) {
                    showToast(result?.error, "error");
                  } else {
                    showToast(
                      "Sincronización finalizada con éxito.",
                      "success"
                    );
                  }
                } catch (e) {
                  console.log(e);
                  setOpenLoader(false);
                  showToast(
                    "Ocurrió un error desconocido. Intenta nuevamente.",
                    "error"
                  );
                }
              },
            },
            {
              label: "Cancelar",
              onClick: () => {},
            },
          ],
        });
        break;

      case "certificate":
        await getContance();
        break;

      case "stadictics":
        showProgressModal(true);
        break;

      case "legal":
        if (legalPage) {
          setShowLegal(true);
        }
        break;

      case "downloads":
        break;
    }
  };

  return (
    <>
      <AppBar
        open={open}
        position="fixed"
        color="primary"
        sx={{ top: "auto", bottom: 0 }}
      >
        <OverlayLoader open={openLoader} />
        <Toolbar disableGutters>
          <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
            <IconButton
              size="large"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              key={"menu-appbar"}
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              open={Boolean(anchorElNav)}
              onClose={handleClickNavMenu}
              sx={{
                display: { xs: "block", md: "none" },
              }}
            >
              {pages.map((page) => (
                <div key={page.id}>
                  {!page.hidden ? (
                    <MenuItem
                      key={"menu1-" + page.id}
                      onClick={() => {
                        handleClickNavMenu(page.id);
                      }}
                    >
                      <ListItemIcon key={"list1-" + page.id}>
                        {page.icon("gray")}
                      </ListItemIcon>
                      <Typography textAlign="center">{page.text}</Typography>
                    </MenuItem>
                  ) : null}
                </div>
              ))}
            </Menu>
          </Box>
          <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
            {pages.map((page) => (
              <div key={page.id}>
                {!page.hidden ? (
                  <MenuItem
                    key={"menu2-" + page.id}
                    onClick={() => {
                      handleClickNavMenu(page.id);
                    }}
                  >
                    <ListItemIcon key={"list2-" + page.id}>
                      {page.icon("white")}
                    </ListItemIcon>
                    <Typography textAlign="center">{page.text}</Typography>
                  </MenuItem>
                ) : null}
              </div>
            ))}
          </Box>
          <Box sx={{ flexGrow: 0 }}>
            <MenuItem
              key={"menu-browser"}
              onClick={() => {
                openSystemBrowser(website);
              }}
            >
              <ListItemIcon key="unique-open">
                <LanguageIcon sx={{ color: "white" }} />
              </ListItemIcon>
              <Typography
                sx={{ flexGrow: 0, display: { xs: "none", md: "flex" } }}
                textAlign="center"
              >
                {"Sitio Web"}
              </Typography>
            </MenuItem>
          </Box>
        </Toolbar>
        {/*<ToastContainer />*/}
        <AlertModal
          key={"legal"}
          open={showLegal}
          title={""}
          content={legalPage ? parse(legalPage) : ""}
          buttonText={"Cerrar"}
          onButtonClick={() => {
            setShowLegal(false);
          }}
        />
      </AppBar>
      <AlertModal
        open={showProgress}
        title={""}
        key={"progress"}
        content={<ProgressModal open={showProgress} />}
        buttonText={"Cerrar"}
        onButtonClick={() => {
          showProgressModal(false);
        }}
        fullScreen
      />
    </>
  );
}

export default memo(MenuFooter);
